import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-coaching-banner',
  templateUrl: './business-coaching-banner.component.html',
  styleUrls: ['./business-coaching-banner.component.scss']
})
export class BusinessCoachingBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
